module.exports = __webpack_public_path__ + "static/media/acura-logo (2).17b2a776.png";